<template>
    <div v-if="form !== null">

        <div class="columns">
            <div class="column is-4 is-offset-4">
                <image-control :image-id="form.image_id"
                               v-model="form.image_id"
                               @event="form.listen(form, $event)"></image-control>

              <form-group type="select"
                          id="company"
                          label="Show On Company Website</small>"
                          v-model="form.company"
                          :error="form.errors.get('company')"
                          @event="form.listen(form, $event)"
                          :option_name="'name'"
                          :option_value="'value'"
                          :options="[
                    {name: 'All Companies', value: ''},
                    {name: 'Crockett', value: 'CF'},
                    {name: 'Bells', value: 'BELLS'},
                ]">
              </form-group>

                <form-group type="text"
                            id="name"
                            label="Page name"
                            v-model="form.name"
                            :error="form.errors.get('name')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            id="title"
                            label="Page title"
                            v-model="form.title"
                            :error="form.errors.get('title')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            id="keywords"
                            label="Page keywords"
                            v-model="form.keywords"
                            :error="form.errors.get('keywords')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="textarea"
                            id="description"
                            label="Page description"
                            v-model="form.description"
                            :error="form.errors.get('description')"
                            @event="form.listen(form, $event)">
                </form-group>

                <button type="button" class="button is-primary"
                        :disabled="apiBusy"
                        @click="createPage()">
                    Create Page
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import Form from "../../helpers/Form"
    import {CREATE_PAGE} from "../../store/mutation-types"
    export default {
        name: 'page-edit',
        data () {
            return {
                form: new Form(this, {
                    company: null,
                    image_id: null,
                    name: '',
                    title: '',
                    description: '',
                    keywords: '',
                }, CREATE_PAGE)
            }
        },
        computed: Object.assign({}, mapGetters(['apiBusy', 'pageContents', 'products', 'bundles'])),
        methods: {
            createPage() {
                this.form.submit().then(data => {
                    this.$router.push({name: 'page', params: {id: data.id}})
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// PageCreate.vue?1ed0b20c